<template>
  <div class="periodicalHome">
    <baseBg bgUrl="periodicalbg"></baseBg>
    <div class="aboutHomeNav w-main">
      <span :class="{ spanAct: pageType === 'page2' }" @click="toPage('page2')">
        《航海》阅读
      </span>
      <span :class="{ spanAct: pageType === 'page1' }" @click="toPage('page1')">
        专业书籍
      </span>
    </div>
    <div class="line w-main"></div>
    <div class="periodicalHome-box w-main">
      <router-link
        v-for="(item, index) in list"
        :key="index"
        :to="{
          path: '/periodical/details',
          query: { id: item.id }
        }"
        tag="div"
        class="boxItem"
      >
        <el-image :src="item.cover" fit="fill"></el-image>
        <div class="boxItemMain">
          <div class="boxItemMain-title">{{ item.name }}</div>
          <div class="boxItemMain-text">{{ item.introduction }}</div>
          <div class="boxItemMain-unit">￥{{ item.price }}</div>
          <div class="boxItemMain-button" @click.stop="showDadilog(item.id)">
            购买咨询
          </div>
        </div>
      </router-link>
      <div class="he40"></div>
      <div v-if="list.length === 0" class="t-c">暂无数据</div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pags.total"
        :page-size.sync="pags.pageSize"
        class="pageBox"
        @current-change="changePage"
      ></el-pagination>
    </div>
    <div class="he50"></div>
    <periodicalDadilog
      v-if="dadilogType"
      :shopid="shopid"
      @hide="hidedadilog"
    />
  </div>
</template>

<script>
import periodicalDadilog from "@/components/pc/periodical/dadilog.vue";
import baseBg from "@/components/pc/base/bg.vue";
import item1 from "@/assets/img/base/item1.png";
import { getPeriodicalList } from "@/api/api.js";

export default {
  name: "PcPeriodicalHome",
  data() {
    return {
      img: {
        item1
      },
      pageType: "page1",
      dadilogType: false,
      pags: {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        categoryId: null
      },
      list: [],
      MagazineList: [],
      shopid: ""
    };
  },
  components: {
    periodicalDadilog,
    baseBg
  },
  watch: {
    $route(newValue) {
      this.toPage(newValue.query.pages);
    }
  },
  mounted() {
    this.toPage(this.$route.query.pages);
  },
  methods: {
    toPage(val) {
      this.pags = {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        categoryId: null
      };
      if (val) {
        this.pageType = val;
        if (val === "page1") {
          this.pags.categoryId = "1";
        } else {
          this.pags.categoryId = "2";
        }
      } else {
        this.pageType = "page2";
        this.pags.categoryId = "2";
      }
      this.getPeriodicalList();
    },
    getPeriodicalList() {
      getPeriodicalList(this.pags).then(res => {
        if (res.code === 0) {
          this.list = res.data.list;
          this.pags.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    hidedadilog() {
      this.dadilogType = false;
    },
    changePage(val) {
      this.pags.pageNum = val;
      this.getPeriodicalList();
    },
    showDadilog(id) {
      this.shopid = id;
      this.dadilogType = true;
    }
  }
};
</script>

<style lang="less">
.periodicalHome {
  &-box {
    display: flex;
    flex-wrap: wrap;
    .boxItem {
      display: flex;
      margin: 20px 1%;
      width: 48%;
      box-sizing: border-box;
      background: rgba(242, 246, 250, 1);
      cursor: pointer;
      .el-image {
        width: 202px;
        height: 270px;
      }
      .boxItemMain {
        width: calc(100% - 202px);
        height: 270px;
        padding: 16px;
        box-sizing: border-box;
        &-title {
          font-size: 22px;
          font-weight: bold;
          color: rgba(52, 52, 52, 1);
        }
        &-text {
          margin: 10px 0 20px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(52, 52, 52, 1);
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
        &-unit {
          margin-bottom: 20px;
          font-size: 22px;
          font-weight: bold;
          color: rgba(255, 26, 26, 1);
        }
        &-button {
          width: 126px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          background: rgba(108, 44, 102, 1);
          cursor: pointer;
        }
      }
    }
    .page2Item {
      display: flex;
      flex-direction: column;
      align-items: center;
      float: left;
      width: 25%;
      margin-bottom: 20px;
      .Item-Img {
        overflow: hidden;
        width: 180px;
        height: 240px;
        background: #d8d8d8;
      }
      .item-name {
        margin: 4px 0;
        width: 180px;
        font-size: 14px;
        color: #141414;
      }
      .item-tiem {
        width: 180px;
        font-size: 14px;
        color: #141414;
      }
    }
  }
  .aboutHomeNav {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    span {
      display: inline-block;
      margin: 0 30px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      color: rgba(52, 52, 52, 1);
      cursor: pointer;
    }
    .spanAct {
      color: rgba(108, 45, 102, 1);
      border-bottom: 2px solid #6c2c66;
    }
  }
  .line {
    height: 1px;
    background: rgba(235, 235, 235, 1);
  }
  .t-c {
    text-align: center;
  }
  .pageBox {
    text-align: center;
    margin: 50px auto 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0f4581;
  }
}
</style>
